export const ANALYTICS_EVENT_NAMES = {
  application: 'Application',
  onboarding: 'Onboarding',
  campaign: 'Campaign',
}
